import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar/Sidebar';
import { SidebarContext } from '../context/SidebarContext';
import { AuthContext } from '../context/AuthContext';
import OnboardingModal from '../components/Onboarding/OnboardingModal';
import './DashboardLayout.css';

export default function DashboardLayout() {
  const { sidebarCollapsed, setSidebarCollapsed } = useContext(SidebarContext);
  const { user } = useContext(AuthContext);

  const needsOnboarding = user && (!user.onboarding || !user.onboarding.completed);

  return (
    <div className={`dashboard-layout ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      {needsOnboarding && <OnboardingModal />}
      
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(v => !v)} />
      
      {/* Mobile Backdrop Overlay */}
      {!sidebarCollapsed && (
        <div 
          className="sidebar-mobile-overlay" 
          onClick={() => setSidebarCollapsed(true)}
        />
      )}

      <main className="dashboard-content">
        <Outlet />
      </main>
    </div>
  );
}